// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-781d0397]{height:30px}.login-btn[data-v-781d0397]{border-color:#000}.btn-text[data-v-781d0397]{font-size:16px;font-weight:500 !important;padding:0 16px;color:#000}.header[data-v-781d0397]{z-index:99}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
